// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__qmNRH","list":"PatternAutocomplete_list__3iCMj"};